/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const InvoiceRowSkeletonMobile = (props) => (
    <ContentLoader
        width={"100%"}
        height={250}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{backgroundColor: "#fff", borderRadius: "4px", marginBottom: "12px"}}
        {...props}>

        {/* Invoice date */}
        <rect x="16" y="16" rx="3" ry="3" width="25%" height="10"/>
        <rect x="16" y="36" rx="3" ry="3" width="25%" height="10"/>

        {/* Billing document */}
        <rect x="50%" y="16" rx="3" ry="3" width="25%" height="10"/>
        <rect x="50%" y="36" rx="3" ry="3" width="25%" height="10"/>

        {/* Accounting document */}
        <rect x="16" y={`calc(30% + 10px)`} rx="3" ry="3" width="25%" height="10"/>
        <rect x="16" y={`calc(30% + 30px)`} rx="3" ry="3" width="25%" height="10"/>

        {/* Invoice amount */}
        <rect x="50%" y={`calc(30% + 10px)`} rx="3" ry="3" width="25%" height="10"/>
        <rect x="50%" y={`calc(30% + 30px)`} ry="3" width="25%" height="10"/>

        {/* Due date */}
        <rect x="16" y={`calc(55% + 10px)`} rx="3" ry="3" width="25%" height="10"/>
        <rect x="16" y={`calc(55% + 30px)`} rx="3" ry="3" width="25%" height="10"/>

        {/* Status */}
        <rect x="50%" y={`calc(55% + 10px)`} rx="3" ry="3" width="25%" height="10"/>
        <rect x="50%" y={`calc(55% + 30px)`} rx="3" ry="3" width="25%" height="10"/>

        {/* Select */}
        <rect x="16" y={`calc(100% - 30px)`} rx="3" ry="3" width="30%" height="10"/>

    </ContentLoader>
);
